const elementContains = (parent, child) => parent !== child && parent.contains(child);

export default elementContains;
